import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { plainToClass } from 'class-transformer';
import { Souscription } from '../../../shared/data/souscription';

@Component({
  selector: 'ngx-show-souscription',
  templateUrl: './show-souscription.component.html',
  styleUrls: ['./show-souscription.component.scss']
})
export class ShowSouscriptionComponent implements OnInit {
  @Input() id: number;
  souscription = new Souscription;
  piece_jointe:any = [];
  constructor(protected dialogRef: NbDialogRef<ShowSouscriptionComponent>,private apiService:ApiService, private router:Router, public toastr: NbToastrService) {
  
  }

  ngOnInit() {
    this.getOneSouscription();
  }

  cancel(){
    this.dialogRef.close();
    
    
  }

  close(){
    this.dialogRef.close();
    
    
  }

  getOneSouscription(){
    this.apiService.getOneSouscriptionProvider(this.id).subscribe(data =>{
     this.souscription = plainToClass(Souscription, data as object);
     // this.piece_jointe = this.message.pieces_jointes;
     
    },(err) =>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }

}
